import React, { useEffect } from "react";
import { Grid, Loader } from 'semantic-ui-react';
import useStatusDetailResponse from "../../hooks/useStatusDetailResponse";
import { useSelector } from "react-redux";


const StatusDetailEdiResponse = ({ediResponseId}) => {
    const {statusDetailResponse, data} = useStatusDetailResponse();
    useEffect(() => {
        statusDetailResponse(ediResponseId);
    }, [])
    const {reconLoader: {statusDetailLoader: {ediLoader}}} = useSelector((state) => state.loader);
    return ( 
        <Grid className="edi-response">
            <Loader style={{marginTop: "10px"}} size="small" active={ediLoader} inline="centered" />
            <Grid.Row>
                <Grid.Column>
                    {data && data?.eventMessage?.edi.map((item, index) => (
                        <div className="edi-repsonse-line"> {item} </div>
                    ))}
                </Grid.Column>
            </Grid.Row>
        </Grid>
     );
}
 
export default StatusDetailEdiResponse;